import React from 'react'
import ActiveItemDivider from './ActiveItemDivider';
import { usePopup } from 'hooks/usePopup';
import { useSoundPath } from 'hooks/useSoundPath';

const ActiveItemMarketplaceBuy = () => {
  const setPopupHook = usePopup();
  const playSound = useSoundPath();

  const buyNowHandler = () => {
    setPopupHook({type: 'purchase'});
    playSound('main');
  }

  return (
    <>
      <div className="card-details__buttons">
        <button className="card-details__button card-details__button--open" onClick={buyNowHandler}>Buy now</button>
      </div>
      <ActiveItemDivider />
    </>
  )
}

export default ActiveItemMarketplaceBuy;
